import { fromJS, Map, List } from 'immutable';
import _ from 'lodash';

import * as actions from './actions';
import * as entityActions from '../Entity/actions';

const initialSliceState = fromJS({
  itemCount: 0,
  items: [],
  itemsPerPage: 0,
  links: [],
  pageCount: 0,
  isLoading: false,
});

function sliceReducer(state = initialSliceState, action) {
  switch (action.type) {
    case entityActions.CREATE.REQUEST:
    case entityActions.DELETE.REQUEST:
    case entityActions.PATCH.REQUEST:
    case actions.FETCH.REQUEST: {
      return state.set('isLoading', true);
    }

    case entityActions.CREATE.SUCCESS: {
      if (!action.payload.result) {
        return state;
      }

      //  Prepend additional item(s)
      const multipleItems = !!action.payload.result.items;
      return state.merge({
        items: multipleItems
          ? new List(action.payload.result.items).concat(state.get('items'))
          : state.get('items').insert(0, new Map(action.payload.result)),
        isLoading: false,
      });
    }

    case entityActions.DELETE.SUCCESS: {
      return state.merge({
        items: state.get('items').filter(item => item.get('id') !== action.payload.id),
        isLoading: false,
      });
    }

    case entityActions.CREATE.FAILURE:
    case entityActions.DELETE.FAILURE:
    case entityActions.PATCH.FAILURE:
    case entityActions.PATCH.SUCCESS:
    case actions.FETCH.FAILURE: {
      return state.set('isLoading', false);
    }

    case actions.FETCH.SUCCESS: {
      const items = action.payload.isInfinitePagination && state.get('items') ? state.get('items')
        .concat(action.payload.result.items) : action.payload.result.items;
      return state.merge(
        {
          ..._.pick(
            action.payload.result,
            [
              'itemCount',
              'itemsPerPage',
              'links',
              'pageCount',
              'metaData',
              'workPreference',
            ],
          ),
          /**
           * If nextPage fetch or fresh fetch
           * Note: only forward possible now
           */
          items,
          isLoading: false,
        },
      );
    }

    default:
      return state;
  }
}

const initialState = new Map();

export default function reducer(state = initialState, action) {
  if (_.get(action, ['payload', 'url']) === undefined) {
    return state;
  }

  switch (action.type) {
    case entityActions.CREATE.REQUEST:
    case entityActions.CREATE.SUCCESS:
    case entityActions.CREATE.FAILURE:
    case entityActions.DELETE.REQUEST:
    case entityActions.DELETE.SUCCESS:
    case entityActions.DELETE.FAILURE:
    case entityActions.PATCH.REQUEST:
    case entityActions.PATCH.SUCCESS:
    case entityActions.PATCH.FAILURE:
    case actions.FETCH.REQUEST:
    case actions.FETCH.SUCCESS:
    case actions.FETCH.FAILURE: {
      return state.set(
        action.payload.url,
        sliceReducer(state.get(action.payload.url), action),
      );
    }

    default:
      return state;
  }
}
